export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const FISCAL_CODE_REGEX =
  /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
export const INTERNATIONAL_NAME_REGEX =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/i;
export const STARTS_WITH_N_LETTERS_REGEX = /^[A-Za-z]/;
export const ALPHANUMERIC_CHARACTERS_REGEX = /^[a-zA-Z0-9]+$/;
export const LETTERS_REGEX = /^[A-Za-z ,.'èéòàùì]*$/;
export const ONLY_LETTERS_REGEX = /^[a-zA-Z ]+$/;
export const ITALIAN_IBAN_REGEX =
  /^IT[0-9]{2}[a-zA-Z][0-9]{5}[0-9]{5}[a-zA-Z0-9]{12}$/;
export const INTERNATIONAL_IBAN_REGEX =
  /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/i;
export const BIC_SWIFT_REGEX = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i;
export const ONLY_LETTERS_AND_NUMBERS = /^[\w\s\dòàèùì']+$/;
export const NUMBERS_ONLY = /^[0-9]+$/;
export const NUMBERS_WITH_KEYBOARD_KEYS =
  /[0-9]|Backspace|Enter|Tab|ArrowLeft|ArrowRight|Delete|[.,]/;
export const CELLPHONE_REGEX = /^((00|\+)39[. ]??)??3\d{2}[. ]??\d{6,7}$/;
export const NUMBERS_FLOAT = /^\d*\.?\d*$/;
export const NUMBERS_FLOAT_COMMA = /^\d*,?\d*$/;
export const NUMBERS_FLOAT_DOT_OR_COMMA = /^\d*[,.]?\d+$/;
export const NEGATIVE_NUMBERS_FLOAT_DOT_OR_COMMA = /^[-]?\d*[,.]?\d+$/;
export const NUMBERS_FLOAT_DOT_OR_COMMA_OR_PLUS = /^\d*[,.+]?\d*$/;
export const NEGATIVE_NUMBERS_FLOAT_DOT_OR_COMMA_OR_PLUS = /^[-]?\d*[,.+]?\d*$/;
export const CELLPHONE_ACCEPTED_INPUT = /^[+]?\d*$/;
export const ONLY_FLOAT_DOT_OR_COMMA = /^\d*[,.]?\d*$/;
export const CAP = /^\d{5}$/;
export const PARTITA_IVA_REGEX = /^\d{11}$/; // TODO Controlla solamente la lunghezza. Da verificare se adottare una utility che effettua i check corretti
export const CODICE_FISCALE_REGEX =
  /^\d{11}$|^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i; // /^\d{11}$|^\w{16}$/; //TODO Controlla solamente la lunghezza. Da verificare se adottare una utility che effettua i check corretti
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?,<>'";:/\\|\][{}=+_\-()^%$#.&]{8,}$/;
export const CURRENCY_WITH_DOT_AND_COMA = /^(?!0\.00)\d{1,3}(.\d{3})*(,\d+)?$/;
export const NEGATIVE_CURRENCY_WITH_DOT_AND_COMA =
  /^[-]?(?!0\.00)\d{1,3}(.\d{3})*(,\d+)?$/;
export const NUMBERS_FLOAT_DOT = /^\d*[.]?\d*$/;
export const NUMBERS_FLOAT_COMA = /^\d*[,]?\d*$/;
export const NEGATIVE_NUMBERS_FLOAT_COMA = /^[-]?\d*[,]?\d*$/;
export const DATE_REGEX = /\d+(?:[.,/-]\d+)+((\s|[T])\d+([:]\d+){1,2})?$/;
export const DATE_PICKER_DD_MM_YYYY =
  /([012]\d|[3]\d)(\/)([0]\d|[1][012])(\/)(\d{4,})$/;
export const DATE_PICKER_YYYY_MM_DD =
  /(\d{4,})(-)([0]\d|[1][012])(-)([012]\d|[3]\d)$/;
export const DATE_PICKER_DD_MM_YYYY_HH_MM =
  /([012]\d|[3]\d)(\/)([0]\d|[1][012])(\/)(\d{4,})(\s([0-1]\d|[2][0123])[:][0-5]\d)?$/;
export const DATE_PICKER_YYYY_MM_DD_HH_MM =
  /(\d{4,})(-)([0]\d|[1][012])(-)([012]\d|[3]\d)((\s|[T])([0-1]\d|[2][0123])[:][0-5]\d([:][0-5]\d)?)?$/;
export const CODICE_DESTINATARIO_FPA_REGEX = /^(\w{6})$/;
export const CODICE_DESTINATARIO_NO_FPA_REGEX = /^(\w{7})$/;
export const TIMESHEET_HOURS_REGEX = /^(\d+h)?(\s*\d+m)?$|^(\d+)$/;

interface RegexLengthProps {
  value: string | undefined | null;
  length: number;
  rex?: RegExp;
}

export const checkRegexAndLength = ({
  value,
  length,
  rex = ALPHANUMERIC_CHARACTERS_REGEX,
}: RegexLengthProps): boolean => {
  const REGEX = new RegExp(`^.{0,${length}}$`);
  return value ? rex.test(value) && REGEX.test(value) : true;
};

export const checkLengthByRegex = ({
  value,
  length,
}: RegexLengthProps): boolean => {
  const REGEX = new RegExp(`^.{0,${length}}$`);
  return value ? REGEX.test(value) : true;
};

export const checkMinLength = ({
  value,
  length,
}: RegexLengthProps): boolean => {
  const REGEX = new RegExp(`^.{${length},}$`);
  return value ? REGEX.test(value) : true;
};

export const checkExactLength = ({
  value,
  length,
}: RegexLengthProps): boolean => {
  const REGEX = new RegExp(`^.{${length},${length}}$`);
  return value ? REGEX.test(value) : true;
};

export const checkMaxRowsNumber = ({
  value,
  length,
}: RegexLengthProps): boolean => {
  if (value) {
    const lines = value.match(/\n/g) ?? '';

    return lines.length + 1 <= length;
  }

  return true;
};

export const isNumericByRegex = (value: string | undefined | null): boolean => {
  const REGEX = new RegExp(NUMBERS_ONLY);
  return value ? REGEX.test(value) : true;
};

export const isNumericGreaterThanZero = (
  value: string | undefined | null,
): boolean => {
  const REGEX = new RegExp(NUMBERS_ONLY);
  if (!value || !REGEX.test(value)) {
    return false;
  }
  return Number(value) > 0;
};

export const isNumericLessThanMax = (
  value: string | undefined | null,
  max: number,
): boolean => {
  const REGEX = new RegExp(NUMBERS_ONLY);
  if (!value || !REGEX.test(value)) {
    return false;
  }
  const numericValue = Number(value);
  return numericValue > 0 && numericValue <= max;
};

export const isNumericBetweenRange = (
  value: string | undefined | null,
  max: number,
  min: number,
): boolean => {
  const REGEX = new RegExp(NUMBERS_ONLY);
  if (!value || !REGEX.test(value)) {
    return false;
  }
  const numericValue = Number(value);
  return numericValue >= min && numericValue <= max;
};

export const validateLengthMessage = (
  value: string,
  maxLength: number,
): Record<string, any> => {
  return {
    value,
    interpolation: {
      numero_caratteri: maxLength,
    },
  };
};

export const validateBetweenRangeMessage = (
  value: string,
  maxLength: number,
  minLength: number,
): Record<string, any> => {
  return {
    value,
    interpolation: {
      numero_min: minLength,
      numero_max: maxLength,
    },
  };
};

function checksumPiva(piva: string): boolean {
  let checksum = 0;
  for (let index = 0; index < 11; index++) {
    let valueCheck = piva.charCodeAt(index) - '0'.charCodeAt(0);
    if ((index & 1) === 1) {
      valueCheck *= 2;
      if (valueCheck > 9) valueCheck -= 9;
    }
    checksum += valueCheck;
  }
  return checksum % 10 === 0;
}

function checksumCodiceFiscale(codiceFiscale: string): boolean {
  let checksum = 0;
  const checkMap = 'BAFHJNPRTVCESULDGIMOQKWZYX';
  for (let index = 0; index < 15; index++) {
    const char = codiceFiscale[index];
    let indexCheck = 0;
    if (char >= '0' && char <= '9')
      indexCheck = char.charCodeAt(0) - '0'.charCodeAt(0);
    else indexCheck = char.charCodeAt(0) - 'A'.charCodeAt(0);
    if ((index & 1) === 0)
      indexCheck = checkMap.charCodeAt(indexCheck) - 'A'.charCodeAt(0);
    checksum += indexCheck;
  }
  return (checksum % 26) + 'A'.charCodeAt(0) === codiceFiscale.charCodeAt(15);
}

export const validatePiva = (piva?: string): boolean => {
  if (!piva) return true;
  if (!PARTITA_IVA_REGEX.test(piva)) return false;
  return checksumPiva(piva);
};

export const validateCodiceFiscale = (codiceFiscale?: string): boolean => {
  if (!codiceFiscale) return true;
  if (PARTITA_IVA_REGEX.test(codiceFiscale)) return checksumPiva(codiceFiscale);
  if (!CODICE_FISCALE_REGEX.test(codiceFiscale)) return false;
  return checksumCodiceFiscale(codiceFiscale);
};

export const STRING_REQUIRED = 'STRING_REQUIRED';
export const STRING_NOT_REQUIRED = 'STRING_NOT_REQUIRED';
export const STRING_REQUIRED_WITH_MIN_LENGTH =
  'STRING_REQUIRED_WITH_MIN_LENGTH';
export const STRING_REQUIRED_WITH_EXACT_LENGTH =
  'STRING_REQUIRED_WITH_EXACT_LENGTH';
export const STRING_REQUIRED_WITH_MAX_LENGTH =
  'STRING_REQUIRED_WITH_MAX_LENGTH';
export const STRING_NOT_REQUIRED_WITH_MAX_ROWS =
  'STRING_NOT_REQUIRED_WITH_MAX_ROWS';
export const STRING_NOT_REQUIRED_WITH_MIN_LENGTH =
  'STRING_NOT_REQUIRED_WITH_MIN_LENGTH';
export const STRING_NOT_REQUIRED_WITH_EXACT_LENGTH =
  'STRING_NOT_REQUIRED_WITH_EXACT_LENGTH';
export const STRING_NOT_REQUIRED_WITH_MAX_LENGTH =
  'STRING_NOT_REQUIRED_WITH_MAX_LENGTH';
export const STRING_REQUIRED_WITH_REGEX = 'STRING_REQUIRED_WITH_REGEX';
export const STRING_NOT_REQUIRED_WITH_REGEX = 'STRING_NOT_REQUIRED_WITH_REGEX';
export const STRING_REQUIRED_CONFIRM = 'STRING_REQUIRED_CONFIRM';
export const BOOLEAN_REQUIRED = 'BOOLEAN_REQUIRED';
export const BOOLEAN_NOT_REQUIRED = 'BOOLEAN_NOT_REQUIRED';
export const NUMERIC_REQUIRED = 'NUMERIC_REQUIRED';
export const NUMERIC_NOT_REQUIRED = 'NUMERIC_NOT_REQUIRED';
export const NUMERIC_NEGATIVE_NOT_REQUIRED = 'NUMERIC_NEGATIVE_NOT_REQUIRED';
export const INTEGER_REQUIRED = 'INTEGER_REQUIRED';
export const INTEGER_REQUIRED_GREATER_THAN_ZERO =
  'INTEGER_REQUIRED_GREATER_THAN_ZERO';
export const INTEGER_NOT_REQUIRED = 'INTEGER_NOT_REQUIRED';
export const INTEGER_REQUIRED_BETWEEN_RANGE = 'INTEGER_REQUIRED_BETWEEN_RANGE';
export const INTEGER_REQUIRED_LESS_THAN_MAX = 'INTEGER_REQUIRED_LESS_THAN_MAX';
export const OBJECT_REQUIRED = 'OBJECT_REQUIRED';
export const OBJECT_NOT_REQUIRED = 'OBJECT_NOT_REQUIRED';
export const STRING_REQUIRED_WITH_REGEX_AND_MAX_LENGTH =
  'STRING_REQUIRED_WITH_REGEX_AND_MAX_LENGTH';
export const STRING_NOT_REQUIRED_WITH_REGEX_AND_MAX_LENGTH =
  'STRING_NOT_REQUIRED_WITH_REGEX_AND_MAX_LENGTH';

export const VALIDATOR_IDS = [
  STRING_REQUIRED,
  STRING_NOT_REQUIRED,
  STRING_REQUIRED_WITH_MIN_LENGTH,
  STRING_REQUIRED_WITH_EXACT_LENGTH,
  STRING_REQUIRED_WITH_MAX_LENGTH,
  STRING_NOT_REQUIRED_WITH_MAX_ROWS,
  STRING_NOT_REQUIRED_WITH_MIN_LENGTH,
  STRING_NOT_REQUIRED_WITH_EXACT_LENGTH,
  STRING_NOT_REQUIRED_WITH_MAX_LENGTH,
  STRING_REQUIRED_WITH_REGEX,
  STRING_NOT_REQUIRED_WITH_REGEX,
  STRING_REQUIRED_CONFIRM,
  BOOLEAN_REQUIRED,
  BOOLEAN_NOT_REQUIRED,
  NUMERIC_REQUIRED,
  NUMERIC_NOT_REQUIRED,
  NUMERIC_NEGATIVE_NOT_REQUIRED,
  INTEGER_REQUIRED,
  INTEGER_REQUIRED_GREATER_THAN_ZERO,
  INTEGER_REQUIRED_LESS_THAN_MAX,
  INTEGER_REQUIRED_BETWEEN_RANGE,
  INTEGER_NOT_REQUIRED,
  STRING_REQUIRED_WITH_REGEX_AND_MAX_LENGTH,
  STRING_NOT_REQUIRED_WITH_REGEX_AND_MAX_LENGTH,
] as const;

export const NESTED_VALIDATOR_IDS = [OBJECT_REQUIRED, OBJECT_NOT_REQUIRED];

export type ValidatorID = (typeof VALIDATOR_IDS)[number];

export type NestedValidatorID = (typeof NESTED_VALIDATOR_IDS)[number];

export type TypeValidator = ValidatorID | NestedValidatorID;

export const isValidatorId = (
  validatorId: TypeValidator,
): validatorId is ValidatorID =>
  VALIDATOR_IDS.includes(validatorId as ValidatorID);

export const isNestedValidatorId = (
  nestedValidatorId: TypeValidator,
): nestedValidatorId is NestedValidatorID =>
  NESTED_VALIDATOR_IDS.includes(nestedValidatorId);

export const MESSAGES = {
  CONSENT: 'messages.validations.consent',
  REQUIRED: 'messages.validations.required',
  IBAN: 'messages.validations.iban',
  BIC_SWIFT: 'messages.validations.bic_swift',
  NUMERIC: 'messages.validations.numeric',
  INTEGER: 'messages.validations.integer',
  INTEGER_GREATER_THAN_ZERO: 'messages.validations.integer.greater_than_zero',
  INTEGER_REQUIRED_LESS_THAN_MAX: 'messages.validations.integer.less_than_max',
  INTEGER_REQUIRED_BETWEEN_RANGE: 'messages.validations.integer.between_range',
  CAP: 'messages.validations.cap',
  EMAIL: 'messages.validations.email',
  RAGIONE_SOCIALE: 'messages.validations.ragione_sociale',
  INDIRIZZO: 'messages.validations.indirizzo',
  LOCALITA: 'messages.validations.localita',
  COMUNE: 'messages.validations.comune',
  REGIONE: 'messages.validations.regione',
  PROVINCIA: 'messages.validations.provincia',
  NAZIONE: 'messages.validations.nazione',
  TELEFONO1: 'messages.validations.telefono1',
  TELEFONO2: 'messages.validations.telefono2',
  TELEFONO3: 'messages.validations.telefono3',
  CAMPO_LIBERO1: 'messages.validations.campo_libero1',
  CAMPO_LIBERO2: 'messages.validations.campo_libero2',
  NOTA_FATTURA: 'messages.validations.nota_fattura',
  CODICE_FISCALE: 'messages.validations.codice_fiscale',
  PARTITA_IVA: 'messages.validations.partita_iva',
  TIPO: 'messages.validations.tipo',
  NOME_CONTATTO: 'messages.validations.nome_contatto',
  TELEFONO: 'messages.validations.telefono',
  NOTA: 'messages.validations.nota',
  DESCRIZIONE: 'messages.validations.descrizione',
  LINK_OGGETTO: 'messages.validations.link_oggetto',
  ID_CODICE: 'messages.validations.id_codice',
  ALIQUOTA_IVA: 'messages.validations.aliquota_iva',
  MAX_LENGTH: 'messages.validations.max_length',
  MIN_LENGTH: 'messages.validations.min_length',
  MAX_ROWS: 'messages.validations.max_rows',
  EXACT_LENGTH: 'messages.validations.exact_length',
  PASSWORD: 'messages.validations.password',
  CONFIRM_PASSWORD: 'messages.validations.confirm_password',
  REGIME_FISCALE: 'messages.validations.ragione_sociale',
  CAUSALE_PAGAMENTO: 'messages.validation.causale_pagamento',
  PERCENTUALE: 'messages.validation.percentuale',
  SEDI_AGGIUNTIVE_TIPO: 'messages.anagrafica_sedi_aggiuntive.tipo',
  SCONTISTICHE_QUANTITA: 'messages.magazzino_scontistica.quantita',
  ANAGRAFICA_EMAIL_EMAIL: 'messages.anagrafica_emails.email',
  ANAGRAFICA_EMAIL_TIPO: 'messages.anagrafica_emails.tipo',
  SEZIONALI_DOCUMENTO_TIPO: 'messages.sezionali_regole.documento_tipo',
  DATE: 'message.validations.date',
  MASTER: 'messages.validations.master',
  CODICE_DESTINATARIO: 'messages.validation.codice_destinatario',
  PEC_DESTINATARIO: 'messages.validation.pec_destinatario',
  PAGAMENTO_SCONTO_FINANZIARIO:
    'messages.validation.pagamento_sconto_finanziario',
};
